import {trackEvent} from '@hconnect/common/logging/Analytics'
import {useRequiredUser} from '@hconnect/login'
import {useUpmPlantContext} from '@hconnect/upm'
import {useCallback} from 'react'

export const useEntersMaterialPlanEvent = () => {
  const {plantId, country, name: plantName} = useUpmPlantContext()
  const {user_id: userId} = useRequiredUser()

  return useCallback(
    (eventProps: Record<string, unknown> = {}) => {
      return trackEvent('userEntersMaterialPlan', {
        product: 'planner',
        feature: 'RMP',
        plantId,
        plantName,
        country,
        userId,
        ...eventProps
      })
    },
    [country, plantId, plantName, userId]
  )
}
